var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", { staticClass: "nav isreturn", on: { click: _vm.toSceneList } }, [
        _c("span", { staticClass: "el-icon-arrow-left" }),
        _c("span", [_vm._v("返回")])
      ]),
      _vm._v(" "),
      _c(
        "el-tabs",
        {
          attrs: { type: "border-card" },
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _c(
            "el-tab-pane",
            { attrs: { label: "扮演客服记录", name: "actAsKf" } },
            [
              _c(
                "div",
                { staticClass: "content-wrap" },
                [
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.list,
                        border: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "beginTime",
                          label: "练习时间",
                          align: "center",
                          width: "150"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "courseName",
                          label: "课程名称",
                          align: "center",
                          "show-overflow-tooltip": "",
                          width: "280"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "callType",
                          label: "呼叫类型",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.callType == "inbund"
                                  ? _c("span", [_vm._v("内呼")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.callType == "outbund"
                                  ? _c("span", [_vm._v("外呼")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c(
                        "el-table-column",
                        { attrs: { label: "练习结果", align: "center" } },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "baseScore",
                              label: "基本条件",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "skillScore",
                              label: "服务技巧",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "riteScore",
                              label: "服务礼仪",
                              align: "center"
                            }
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "flowScore",
                              label: "服务流程",
                              align: "center"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "callInterval",
                          label: "时长(秒)",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "gradeScore",
                          label: "分数",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: { label: "操作", align: "center" },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c(
                                  "a",
                                  {
                                    staticClass: "link-text",
                                    attrs: {
                                      href:
                                        "/tjkStudy/train/eachRecordDetail?id=" +
                                        scope.row.id +
                                        "&kf=" +
                                        _vm.tjkId,
                                      target: "_blank"
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "查看详情" + _vm._s(_vm.searchData.total)
                                    )
                                  ]
                                )
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: {
                      pages: _vm.searchData.pages,
                      pageNum: _vm.searchData.pageNum
                    },
                    on: { getData: _vm.getList }
                  })
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "el-tab-pane",
            { attrs: { label: "扮演客户记录", name: "actAsKh" } },
            [
              _c(
                "div",
                { staticClass: "content-wrap" },
                [
                  _c("el-form", { attrs: { inline: true } }),
                  _vm._v(" "),
                  _c(
                    "el-table",
                    {
                      staticStyle: { width: "100%" },
                      attrs: {
                        data: _vm.listActKh,
                        border: "",
                        "highlight-current-row": ""
                      }
                    },
                    [
                      _c("el-table-column", {
                        attrs: {
                          prop: "beginTime",
                          label: "扮演时间",
                          align: "center"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "courseName",
                          label: "课程名称",
                          align: "center",
                          "show-overflow-tooltip": "",
                          width: "280"
                        }
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "callType",
                          label: "呼叫类型",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                scope.row.callType == "inbund"
                                  ? _c("span", [_vm._v("内呼")])
                                  : _vm._e(),
                                _vm._v(" "),
                                scope.row.callType == "outbund"
                                  ? _c("span", [_vm._v("外呼")])
                                  : _vm._e()
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "teacherName",
                          label: "练习对象",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.teacherName) +
                                    "（" +
                                    _vm._s(scope.row.teacherTjkNumber) +
                                    "）\n            "
                                )
                              ]
                            }
                          }
                        ])
                      }),
                      _vm._v(" "),
                      _c("el-table-column", {
                        attrs: {
                          prop: "videoUrl",
                          label: "练习录音",
                          align: "center"
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function(scope) {
                              return [
                                _c("audio", {
                                  attrs: {
                                    src: scope.row.videoUrl,
                                    controls: "controls"
                                  }
                                })
                              ]
                            }
                          }
                        ])
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("pagination", {
                    attrs: {
                      pages: _vm.searchData.pages,
                      pageNum: _vm.searchData.pageNum
                    },
                    on: { getData: _vm.getList }
                  })
                ],
                1
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-568bd7b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-568bd7b7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/train/record/eachExerciseRecordAll.vue
// module id = 1620
// module chunks = 0